import data from "../../../../../packages/react/src/Pagination/Pagination.docs.json";
import State from "../../../../components/State";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  data,
  State,
  DeprecationBanner,
  React
};